// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Icon$Catalyst from "../../generic/icons/Icon.bs.js";
import * as ErrorUtils$Catalyst from "../../../utils/ErrorUtils.bs.js";
import * as TertiaryButton$Catalyst from "../../generic/buttons/TertiaryButton.bs.js";

function ErrorDisplayComponent(Props) {
  var error = Props.error;
  var refreshView = Props.refreshView;
  var classNameOpt = Props.className;
  var refreshTextOpt = Props.refreshText;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var refreshText = refreshTextOpt !== undefined ? refreshTextOpt : "Try reloading the page";
  return React.createElement("div", {
              className: "error-container " + className
            }, React.createElement(Icon$Catalyst.WarningIcon.make, {
                  fontSize: "Large"
                }), React.createElement("div", {
                  className: "error-message"
                }, ErrorUtils$Catalyst.resolveError(error)), refreshView !== undefined ? React.createElement(TertiaryButton$Catalyst.make, {
                    className: "text-styling-cat-items",
                    onSelectCB: refreshView,
                    children: refreshText
                  }) : null);
}

var make = ErrorDisplayComponent;

export {
  make ,
  
}
/* react Not a pure module */
